// extracted by mini-css-extract-plugin
export default {"FinalTab":"FinalTab_FinalTab__SQhww"};